import React from "react";
import logo from "../assets/icon/unilever_logo.gif"

const MaintenancePage: React.FC = () => {
  return (
    <div style={styles.container}>
      <div className="mb-1">
        <img src={logo} alt="logo" height="350px"/>
      </div>
      <h1 style={styles.title}>We'll be back soon!</h1>
      <p style={styles.message}>
        Our site is currently undergoing maintenance.
        <br />
        if any queries, please check with Admin team.
      </p>
      <p className="footer-text">© {new Date().getFullYear()} Unilever. All Rights Reserved.</p>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    textAlign: "center",
    padding: "20px",
  },
  title: {
    fontSize: "2.5rem",
    marginBottom: "20px",
  },
  message: {
    fontSize: "1.2rem",
    color: "#555",
  },
};

export default MaintenancePage;
